/** A request rejected before a reservation was accepted. */
export class BookingRejectedError extends Error {}
